import * as React from 'react'
import { Text, Colors } from '@doordash/design-language'
import t from './strings'

export const FirstDashContent = ({ isSubmarketBusy, hasDashNowBenefit }) => {
  if (isSubmarketBusy) {
    return (
      <Text styles={Text.Styles.Body1} color={Colors.SystemGrey80}>
        {t.busy.content1()}
      </Text>
    )
  } else if (hasDashNowBenefit) {
    return (
      <React.Fragment>
        <Text styles={Text.Styles.Body1} color={Colors.SystemGrey80}>
          {t.schedule.content1()}
        </Text>
        <Text styles={Text.Styles.Body1} color={Colors.SystemGrey80}>
          {t.schedule.content2()}
        </Text>
      </React.Fragment>
    )
  }
  return (
    <Text styles={Text.Styles.Body1} color={Colors.SystemGrey80}>
      {t.scheduleFirstDash.content1()}
    </Text>
  )
}
